import ObjectHelper from "@/utils/object-helper";

export default class Merchant {
  constructor(data = {}) {
    this.id = data.merchantId || data.id;
    this.name = data.paymentCompanyName || data.name;
    this.logoUrl = data.paymentCompanyLogoUrl || data.logoUrl;
    this.canSchedulePayment = data.isScheduledGuestCreditCardPaymentAllowed;
    this.canScheduleOverduePayments =
      data.isScheduledGuestCreditCardPaymentForPastDueInvoicesAllowed || data.canScheduleOverduePayments;
    this.existingPaymentMethodSaved = data.existingPaymentMethodSaved;
    this.isAvsEnabled = data.isAvsEnabled;
    this.enquiriesNumber = data.enquiriesNumber;
    this.enquiriesContactName = data.enquiriesContactName;
    this.merchantEmailAddress = data.merchantEmailAddress || "payersupport@wise-sync.com";
    this.localeName = data.localeName || "en-AU";
    this.currency = (data.invoiceCurrencyCode && data.invoiceCurrencyCode.toUpperCase()) || "AUD";
    this.paymentTypes = {};
    this.paymentTypes.creditCards = ObjectHelper.getSafe(() => data.paymentTypes.creditCards, {});
    this.paymentTypes.creditCards.surchargeLabel = this.paymentTypes.creditCards.surchargeLabel || "surcharge";
    this.paymentTypes.creditCards.maxLimit = this.paymentTypes.creditCards.maxLimit || 0;
    this.paymentTypes.creditCards.types = this.paymentTypes.creditCards.types || [];
    this.paymentTypes.bankDebit = ObjectHelper.getSafe(() => data.paymentTypes.bankDebit, {});
    this.paymentTypes.bankDebit.maxLimit = this.paymentTypes.bankDebit.maxLimit || 0;
    this.paymentTypes.bankDebit.prefixAccountLabel = this.paymentTypes.bankDebit.prefixAccountLabel || "BSB";
    this.paymentTypes.bankDebit.prefixAccountLabelTwo = this.paymentTypes.bankDebit.prefixAccountLabelTwo || null;
    this.paymentTypes.bankDebit.accountNumberLabel = this.paymentTypes.bankDebit.accountNumberLabel || "Account Number";
    this.overrideSurcharge = false;
    this.merchantAccountingPackage = data.merchantAccountingPackage || null;
  }

  get isCreditCardAccepted() {
    return this.paymentTypes.creditCards.maxLimit > 0 || this.paymentTypes.creditCards.types.length;
  }

  get isBankDebitAccepted() {
    return this.paymentTypes.bankDebit.maxLimit > 0;
  }

  get currencySymbol() {
    let currencySymbols = {
      $: ["USD", "CAD", "AUD", "NZD", "SGD"],
      "€": ["EUR"],
      "£": ["GBP"],
    };
    return Object.keys(currencySymbols).find((symbol) => currencySymbols[symbol].includes(this.currency));
  }

  get locale() {
    const locales = {
      Australia: "en-AU",
      "New Zealand": "en-NZ",
      "United Kingdom": "en-GB",
      "United States": "en-US",
      Canada: "en-CA",
      Ireland: "en-IE",
      Singapore: "en-SG",
    };
    return locales[this.localeName] || "en-AU";
  }
}
